import { CESimpleAttributePermissionRuleBase } from './ce-simple-attribute-permission-rule-base'


export class CESimpleAttributePermissionRule extends CESimpleAttributePermissionRuleBase {

}